<template lang="pug">
	.audio-tracker-video-player.flex-row.center.align-center(ref="recorder")
		.video-frame.screen-flow(ref="videoFrame", :style="{ width: videoWidth && `${videoWidth}px`, '--height': `${height}px` }")
			video(v-if="video1SrcData", :class="{ hidden: activeVideo !== 'video1' }", ref="video1", muted="muted", @canplaythrough="onCanPlay('video1')")
				source(:src="video1SrcData")
			video(v-if="video2SrcData", :class="{ hidden: activeVideo !== 'video2' }", ref="video1", muted="muted", @canplaythrough="onCanPlay('video2')")
				source(:src="video2SrcData")
		.vertical-resizer(@mousedown="startResizing")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import VueTypes from 'vue-types';
	import { saveAs } from 'file-saver';
	import videoHelper from 'view/audioTracker/video-helper';
	import storage from 'storage';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-video-player',
		components: {
			DxButton
		},
		props: {
			isPlaying: VueTypes.bool.def(false),
			tracker: VueTypes.any.def(null),
			currentTime: VueTypes.number.def(0),
			videoData: VueTypes.any.def(null),
			track: VueTypes.any.def(null),
			nextVideoData: VueTypes.any.def(null),
			nextTrack: VueTypes.any.def(null)
		},
		data() {
			return {
				video1SrcData: this.videoData,
				video2SrcData: this.nextVideoData,
				video1CanPlay: false,
				video2CanPlay: false,
				activeVideo: 'video1',
				videoWidth: null,
				heightProp: storage.prop('creativeVideoPlayer_height', void 0, 200)
			};
		},
		computed: {
			nextVideoId() {
				return this.activeVideo === 'video1' ? 'video2' : 'video1'
			},
			videoSrcData: {
				get: function() { return this.activeVideo === 'video1' ? this.video1SrcData : this.video2SrcData; },
				set: function(v) { this.$set(this, `${this.activeVideo}SrcData`, v); }
			},
			nextVideoSrcData() {
				return this.activeVideo === 'video1' ? this.video2SrcData : this.video1SrcData;
			},
			video: {
				get: function() { return this.$refs[this.activeVideo]; },
				cache: false
			},
			nextVideo: {
				get: function() { return this.$refs[this.nextVideoId]; },
				cache: false
			},
			height: {
				get: function() { return this.heightProp.value; },
				set: function(v) { this.heightProp.value = v; }
			}
		},
		watch: {
			currentTime(v) {
				if (__DEBUG__)
					console.debug('Current time changed', v);
				this.calcVideoTime();
			},
			isPlaying() {
				this.checkPlaying();
			},
			videoData(v) {
				if (this.nextVideoSrcData && this.nextVideoSrcData === v) {
					this[`${this.activeVideo}SrcData`] = this.nextVideo;
					this.switchVideo();
				} else {
					this.videoSrcData = null;
					this.$nextTick(() => {
						this[`${this.activeVideo}SrcData`] = this.videoData;
						this[`${this.activeVideo}CanPlay`] = false;
					});
				}
				this.play();
				this.$calcVideoTime();
			}
		},
		mounted() {
			if (__DEBUG__) {
				window.videoPlayer = this;
			}

			this.$calcVideoTime = _.debounce(this.calcVideoTime, 100, {
				leading: false,
				trainling: true,
				maxWait: 200
			});

			if (this.isPlaying) {
				this.checkPlaying();
			}

			document.body.addEventListener('mousemove', this.onMouseMove);
			document.body.addEventListener('mouseup', this.onMouseUp);
		},
		destroyed() {
			if (this.$playDelay) clearTimeout(this.$playDelay);
			delete this.$playDelay;
			document.body.removeEventListener('mousemove', this.onMouseMove);
			document.body.removeEventListener('mouseup', this.onMouseUp);
		},
		methods: {
			startResizing(e) {
				this.$isRezizing = true;
				this.$initHeight = this.height;
				this.$startResizingEvt = e;
			},
			onMouseMove(e) {
				if (this.$isRezizing) {
					const delta = e.pageY - this.$startResizingEvt.pageY;
					this.videoWidth = null;
					this.height = this.$initHeight + delta;
				}
			},
			onMouseUp() {
				if (this.$isResizing) {
					this.calcWidth();
				}
				this.$isRezizing = false;
			},
			checkPlaying() {
				if (!this.track) return;
				if (this.$playDelay) clearTimeout(this.$playDelay);
				if (this.isPlaying) {
					const playDelay = Math.max(0, this.track.start - this.tracker.currentTime);
					if (playDelay) {
						if (__DEBUG__)
							console.debug('Play with delay', { playDelay });
						this.$playDelay = setTimeout(this.play, playDelay * 1000);
					} else {
						this.play();
					}
				} else {
					this.play();
				}
			},
			switchVideo() {
				this.activeVideo = this.nextVideoId;
				this.calcWidth();
			},
			async test() {
				//const url = require('assets/big_buck_bunny_240p_1mb.mp4');
				const canvas = document.createElement('canvas');
				canvas.width = this.track?.__canvasWidth;
				canvas.height = this.track?.__canvasHeight;
				const imageWidth = 50;
				const imagesCount = parseInt(this.track?.__canvasWidth / imageWidth);
				const eachSeconds = this.track?.trimmedDuration / imagesCount;

				if (__DEBUG__)
					console.debug('Process', { imagesCount, eachSeconds, dur: this.track?.trimmedDuration })

				videoHelper.buildVideo(this.track.__base64, (res) => {
					if (__DEBUG__)
						console.debug('buff', { res });
					saveAs(new Blob([res.video.buffer]), 'testx.mp4')
				}, {
					//maxHeight: 100,
					onVideoFrameReady: ({ bmp, frameNumber, fps, timestamp }) => {
						if (frameNumber % parseInt(eachSeconds * fps) === 0) {
							if (__DEBUG__)
								console.debug(`${frameNumber} frame`, { bmp, eachSeconds, fps, imagesCount, timestamp });
						}
					}
				});
			},
			play(forced) {
				let isPlaying = forced !== void 0 ? forced : this.isPlaying;
				this.isPlaying = isPlaying;
				if (this._isDestroyed || !this[`${this.activeVideo}CanPlay`] || !this.video) return;
				this.calcVideoTime();
				if (__DEBUG__)
					console.debug('Play video', { isPlaying, time: this.video?.currentTime });
				if (isPlaying && this.tracker.currentTime >= (this.track?.start || 0)) {
					this.video.play();
					this.calcWidth();
				} else
					this.video.pause();
			},
			calcVideoTime() {
				if (this.video)
					this.video.currentTime = Math.max(0, this.tracker.currentTime - (this.track?.start || 0));
			},
			calcWidth() {
				setImmediate(() => {
					this.videoWidth = null;
					setImmediate(() => this.videoWidth = this.$refs.videoFrame.offsetWidth);
				});
			},
			onCanPlay(video) {
				if (this[`${this.activeVideo}CanPlay`]) return;
				if (__DEBUG__) 
					console.debug(`${this.activeVideo}CanPlay`, { state: this.isPlaying });
				this.calcWidth();
				this[`${video}CanPlay`] = true;
				if (video === this.activeVideo) {
					this.checkPlaying();
				}
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-video-player {
		@import "main/themes/generated/variables.base.scss";

		--border: 1px solid rgb(207,207,207);
		--bg-color: #d7d7d7c9;
		--bg-offset: 10px;
		--bg-size: 10px;
		border: var(--border);
		background: repeating-linear-gradient( 45deg, transparent, transparent 100px, #e2e2e2 100px, #e9e9e9 200px);
		position: relative;

		.video-frame {
			height: 100%;
			background: var(--bg-color);
			height: var(--height);
			border-left: var(--border);
			border-right: var(--border);
			position: relative;

			> video {
				height: 100%;
				/*border-top: 4px solid var(--bg-color);
				border-bottom: 4px solid var(--bg-color);*/
			}
		}

		.screen-flow {
			background-color: rgb(214,214,214);
			margin-left: 80px;
			margin-right: 80px;
			position: relative;
			
		}

		.screen-flow:before {
			content: "";
			/*background: -moz-linear-gradient(top, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px), 
						-moz-linear-gradient(left, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px),
						-moz-linear-gradient(right, var(--bg-color) var(--bg-offset), rgba(0, 0, 0, 0) 4px);
			background: -webkit-linear-gradient(top, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px), 
						-webkit-linear-gradient(left, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px),
						-webkit-linear-gradient(right, var(--bg-color) var(--bg-offset), rgba(0, 0, 0, 0) 4px);*/
			/*background-size: 100% 20px;
			background-repeat: repeat-y;*/
			background: var(--bg-color);
			height: 100%;
			width: 4px;
			display: block;
			position: absolute;
			left: -3px;
			opacity: 1;
			border-bottom: 1px solid var(--bg-color);
		}

		.screen-flow:after {
			content: "";
			/*background: 
						-moz-linear-gradient(left, var(--bg-color) var(--bg-offset), rgba(0, 0, 0, 0) 10px),
						-moz-linear-gradient(top, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px),
						-moz-linear-gradient(right, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px);
			background: -webkit-linear-gradient(left, var(--bg-color) var(--bg-offset), rgba(0, 0, 0, 0) 4px),
						-webkit-linear-gradient(top, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px),
						-webkit-linear-gradient(right, var(--bg-color) var(--bg-size), rgba(0, 0, 0, 0) 10px);
			background-size: 100% 20px;
			background-repeat: repeat-y;*/
			background: var(--bg-color);
			height: 100%;
			width: 4px;
			display: block;
			position: absolute;
			right: -3px;
			opacity: 1;
			top: 0px;
			border-bottom: 1px solid var(--bg-color);
		}

		.vertical-resizer {
			position: absolute;
			bottom: 0px;
			height: 10px;
			width: 100%;
			background: transparent;
			cursor: n-resize;

			&:hover {
				background: rgba(0,0,0,0.025);
			}
		}
	}
</style>
